import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import styles from './ChatScrollLayout.css';

type TProps = {
  isLoading: boolean;
  hasButtonSeparator: boolean;
  pagesNode: React.ReactNode;
  chatbotOnboardingNode: React.ReactNode;
  chatbotButtonsNode: React.ReactNode;
  removalDateNode: React.ReactNode;
  archiveInfoNode: React.ReactNode;
  rootRef: React.RefObject<HTMLDivElement>;
};

export const ChatScrollLayout: React.FC<TProps> = ({
  isLoading,
  hasButtonSeparator,
  pagesNode,
  removalDateNode,
  archiveInfoNode,
  chatbotOnboardingNode,
  chatbotButtonsNode,
  rootRef,
}) => {
  return (
    <>
      <div className={styles['pages']} ref={rootRef}>
        {isLoading && (
          <div className={styles['preloader']}>
            <Spinner size={16} />
          </div>
        )}
        {pagesNode}
        {chatbotOnboardingNode}
        {hasButtonSeparator && <div className={styles['separator']} />}
        {chatbotButtonsNode}
      </div>
      {removalDateNode}
      {archiveInfoNode}
    </>
  );
};
